import React from 'react';
import GoogleIcon from 'assets/img/google-icon.svg';

type PropType = {
  onClick: (response: any) => void
}
const GoogleLoginButton: React.FC<PropType> = ({ children, onClick }) => {

  return (
    <button className="btn-login-google" onClick={onClick}>
      <img src={GoogleIcon} alt="" /> {children}
    </button>
  );
};

export default GoogleLoginButton;
